<script>
	import IconSocialsFacebook from '../images/icons-socials/IconSocialsFacebook.svelte';
	import IconSocialsInstagram from '../images/icons-socials/IconSocialsInstagram.svelte';
	import IconSocialsLinkedin from '../images/icons-socials/IconSocialsLinkedin.svelte';
	import IconSocialsXing from '../images/icons-socials/IconSocialsXing.svelte';
</script>

<footer>
	<ul>
		<li class="stretch_mobile">Folge uns:</li>
		<li>
			<a aria-label="Facebook" href="https://de-de.facebook.com/BurgEins" target="_blank">
				<IconSocialsFacebook/>
			</a>
		</li>
		<li>
			<a aria-label="Instagram" href="https://www.instagram.com/burgeins" target="_blank">
				<IconSocialsInstagram/>
			</a>
		</li>
		<li>
			<a aria-label="LinkedIn" href="https://de.linkedin.com/company/burgeins" target="_blank">
				<IconSocialsLinkedin/>
			</a>
		</li>
		<li>
			<a aria-label="Xing" href="https://www.xing.com/pages/burgeinsgmbh" target="_blank">
				<IconSocialsXing/>
			</a>
		</li>
	</ul>
</footer>

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";
	
	footer {
		height: 11em;
		width: 100%;
		position: relative;
		bottom: 0;
		display: flex;
		text-transform: uppercase;
		
		margin-top: auto; /* makes footer stick to bottom */
		margin-bottom: 5.5em;

		@include for-tablet-portrait-up {
			height: 9em;
			margin-bottom: 0;
		}

		&:after {
			content: "";
			display: block;
			position: absolute;
			top: 0;
			height: 100%;
			width: 100vw;
			background-color: black;
			z-index: -1;
		}
		
		ul {
			background-color: black;
			position: relative;
			width: 100%;
			pointer-events: auto;
			list-style: none;
			display: inline-flex;
			justify-content: center;
			align-items: stretch;
			padding: var(--spacing-mobile);
			flex-wrap: wrap;
			gap: px-to-em(25);

			@include for-phone-only {
				gap: 0 10vw;
				justify-content: left;
			}
			@include for-tablet-portrait-up {
				flex-wrap: nowrap;
				align-items: center;
			}
			
			@include for-tablet-landscape-up {
				padding: calc(var(--spacing-mobile) * 2);
			}
			
			li {
				list-style: none;
				flex-grow: 0;
				flex-shrink: 1;
				flex-basis: auto;
				color: white;
				flex-wrap: wrap;
				padding: 0;
				width: auto;
				@include font-px-to-rem(18, 18, 600);

				:global(a) {
					align-items: center;
					display: flex;
					@include font-px-to-rem(18, 18, 600);
				}

				@include for-tablet-portrait-up {
					text-align: end;
				}
				
				@include for-tablet-landscape-up {
					font-size: 1.8rem;
				}

				&.stretch_mobile {
					@include for-phone-only {
						width: 100%;
					}
				}
			}
		}
		
		:global(svg) {
			height: 1em;
			fill: white;
			@include for-phone-only {
				height: 2em;
			}
		}
	}
</style>
